import { c as _c } from "react/compiler-runtime";
import CliLoginCommandCopyableField from '../../../../common/CliLoginCommandCopyableField';
interface Props {
  nextStep: () => void;
}
const RunHookdeckLogin: React.FC<Props> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CliLoginCommandCopyableField />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default RunHookdeckLogin;